<ng-container *ngIf="loader">
   <ngx-skeleton-loader count="15" appearance="line" animation="progress"
      [theme]="{ height: '60px', width: '100%', margin: '0px 0px 8px 0px' }">
   </ngx-skeleton-loader>
</ng-container>

<ng-container *ngIf="!loader && relatedStocks && relatedStocks.length > 0">
   <div class="px-lg-3" *ngIf="isMobile">
      <div class="table-responsive mobile-table-wrapper">
         <h4 class="mb-0 table-sec-heading">
            {{
            complianceStatus == "COMPLIANT"
            ? 'Related Halal Stocks to ' + name + ' (' + ticker + ')'
            : 'Alternate Halal Stocks for ' + name + ' (' + ticker + ')'
            }}
         </h4>
         <p class="description_seo mt-2 pb-1">Related Halal Stocks are Shariah-compliant companies that align with
            Islamic investment principles, avoiding prohibited industries like alcohol, gambling, and interest-based
            finance.</p>

         <table class="table mb-0">
            <thead>
               <tr>
                  <th class="text-uppercase fw-normal" scope="col"></th>
                  <th class="text-uppercase fw-normal" scope="col">Name</th>
                  <th class="text-uppercase fw-normal text-end" scope="col">
                     Price & 1D CHG
                  </th>
                  <th class="text-uppercase fw-normal text-end" scope="col">
                     Market Cap
                  </th>
                  <th class="text-uppercase fw-normal text-center" scope="col">
                     Rating
                  </th>
               </tr>
            </thead>
            <tbody>
               <ng-container *ngIf="relatedStocks.length > 0; else noStocks">
                  <tr *ngFor="
                        let stock of relatedStocks
                           | orderBy : orderFieldName : orderDirection
                     ">
                     <td class="align-middle p-0 star-td">
                        <app-watchlist-button [stock]="stock"></app-watchlist-button>
                     </td>
                     <td class="align-middle p-0">
                        <a class="d-flex align-items-center gap-2 text-decoration-none stock-image-and-name"
                           href="/stock/{{ stock.stockName }}/">
                           <div
                              class="stock-image-wrapper border flex-shrink-0 bg-light rounded-circle overflow-hidden">
                              <img [src]="stock.logo" [alt]="" class="img-fluid" *ngIf="stock.logo" />
                              <div *ngIf="!stock.logo"
                                 class="d-flex h-100 text-black align-items-center justify-content-center fs-5 fw-bold">
                                 {{ stock.companyName.charAt(0) }}
                              </div>
                           </div>
                           <div class="d-block">
                              <h5 class="mb-0 line-clamp-1 stock-name">
                                 {{ stock.companyName }}
                              </h5>
                              <p class="mb-0 line-clamp-1 stock-symbol">
                                 {{ stock.stockName }}
                              </p>
                           </div>
                        </a>
                     </td>
                     <td class="align-middle p-0 price-and-change-td">
                        <a class="d-flex align-items-center justify-content-end gap-2 text-decoration-none stock-price-and-change"
                           href="/stock/{{ stock.stockName }}/">
                           <div class="d-grid">
                              <div>
                                 <span class="stock-price text-end" *ngIf="
                                       stock.price || stock.lastPrice;
                                       else noPrice
                                    ">
                                    {{
                                    (stock.price
                                    ? stock.price
                                    : stock.lastPrice
                                    ) | sumPipe : stock.currency || ""
                                    }}
                                 </span>
                                 <ng-template #noPrice>-</ng-template>
                              </div>

                              <div class="stock-change d-flex align-items-center justify-content-end gap-1" *ngIf="
                                    stock.percentChange;
                                    else noPercentChange
                                 ">
                                 <i class="bi" [ngClass]="
                                       getIconClasses(stock.percentChange)
                                    "></i>
                                 <span [ngClass]="
                                       getPercentChangeClasses(
                                          stock.percentChange
                                       )
                                    ">
                                    {{
                                    stock.percentChange
                                    | abs
                                    | number : "1.2-2"
                                    }}%
                                 </span>
                              </div>
                              <ng-template #noPercentChange>-</ng-template>
                           </div>
                        </a>
                     </td>
                     <td class="align-middle p-0 compliance-td">
                        <a class="d-flex align-items-center justify-content-end gap-2 text-decoration-none stock-compliance"
                           href="/stock/{{ stock.stockName }}/">
                           <app-compliance-chip [symbol]="stock.ticker" [preloaded]="true"
                              [complianceStatus]="stock?.shariahCompliantStatus"
                              [complianceRankingV2]="stock?.ranking_v2" [onlyCompliance]="true" [preloaded]="true">
                           </app-compliance-chip>
                        </a>
                     </td>
                     <td class="align-middle p-0 compliance-td">
                        <a class="d-flex align-items-center justify-content-end gap-2 text-decoration-none stock-compliance"
                           href="/stock/{{ stock.stockName }}/">
                           <app-compliance-chip [symbol]="stock.ticker" [preloaded]="true"
                              [complianceStatus]="stock?.shariahCompliantStatus"
                              [complianceRankingV2]="stock?.ranking_v2" [onlyRanking]="true" [preloaded]="true">
                           </app-compliance-chip>
                        </a>
                     </td>
                  </tr>
               </ng-container>
               <ng-template #noStocks>
                  <tr class="bg-white no-data-tr">
                     <td class="align-middle text-center p-3" colspan="6">
                        0 matching stocks
                     </td>
                  </tr>
               </ng-template>
            </tbody>
         </table>
      </div>
   </div>

   <div class="table-responsive desktop-table-wrapper" *ngIf="!isMobile">
      <h4 class="mb-0 table-sec-heading">
         {{
         complianceStatus == "COMPLIANT"
         ? "Related Halal Stocks to " + name + " (" + ticker + ")"
         : "Alternate Halal Stocks for " + name + " (" + ticker + ")"
         }}
      </h4>
      <p class="description_seo">Related Halal Stocks are Shariah-compliant companies that align with
         Islamic investment principles, avoiding prohibited industries like alcohol, gambling, and interest-based
         finance.</p>

      <table class="table mb-0">
         <thead>
            <tr>
               <th class="text-uppercase fw-normal" scope="col"></th>
               <th class="text-uppercase fw-normal" scope="col">Name</th>
               <!-- <th class="text-uppercase fw-normal text-end" scope="col">Market Cap</th> -->
               <th class="text-uppercase fw-normal text-end" scope="col">
                  Price
               </th>
               <th class="text-uppercase fw-normal text-end" scope="col">
                  1D Change
               </th>
               <th class="text-uppercase fw-normal text-end" scope="col">
                  Market Cap
               </th>
               <th class="text-uppercase fw-normal text-center" scope="col">
                  Rating
               </th>
            </tr>
         </thead>
         <tbody>
            <ng-container *ngIf="relatedStocks.length > 0; else noStocks">
               <tr *ngFor="let stock of relatedStocks">
                  <td class="align-middle p-0 star-td">
                     <app-watchlist-button [stock]="stock"></app-watchlist-button>
                  </td>
                  <td class="align-middle p-0">
                     <a class="d-flex align-items-center gap-2 text-decoration-none stock-image-and-name"
                        href="/stock/{{ stock.stockName }}/">
                        <div class="stock-image-wrapper border flex-shrink-0 bg-light rounded-circle overflow-hidden">
                           <img [src]="stock.logo" [alt]="" class="img-fluid" *ngIf="stock.logo" />
                           <div *ngIf="!stock.logo"
                              class="d-flex h-100 text-black align-items-center justify-content-center fs-5 fw-bold">
                              {{ stock.companyName.charAt(0) }}
                           </div>
                        </div>
                        <div class="d-block">
                           <h5 class="mb-0 line-clamp-1 stock-name">
                              {{ stock.companyName }}
                           </h5>
                           <p class="mb-0 line-clamp-1 stock-symbol">
                              {{ stock.stockName }}
                           </p>
                        </div>
                     </a>
                  </td>
                  <!-- <td class="align-middle p-0 market-price-td">
                     <a class="d-flex align-items-center justify-content-end gap-2 text-decoration-none stock-market-price" href="/stock/{{stock.stockName}}/">
                        <span>{{ stock.exchangeMarketCap | currencyMilion: stock.currency : stock.exchangeMarketCap }}</span>
                     </a>
                  </td> -->
                  <td class="align-middle p-0 price-td">
                     <a class="d-flex align-items-center justify-content-end gap-2 text-decoration-none stock-price"
                        href="/stock/{{ stock.stockName }}/">
                        <span *ngIf="stock.price || stock.lastPrice; else noPrice">
                           {{
                           (stock.price ? stock.price : stock.lastPrice)
                           | sumPipe : stock.currency || ""
                           }}
                        </span>
                        <ng-template #noPrice>-</ng-template>
                     </a>
                  </td>
                  <td class="align-middle p-0 change-td">
                     <a class="d-flex align-items-center justify-content-end gap-2 text-decoration-none stock-change"
                        href="/stock/{{ stock.stockName }}/">
                        <div class="d-flex align-items-center gap-1" *ngIf="stock.percentChange; else noPercentChange">
                           <i class="bi" [ngClass]="getIconClasses(stock.percentChange)"></i>
                           <span [ngClass]="
                                 getPercentChangeClasses(stock.percentChange)
                              ">
                              {{
                              stock.percentChange | abs | number : "1.2-2"
                              }}%
                           </span>
                        </div>
                        <ng-template #noPercentChange>-</ng-template>
                     </a>
                  </td>
                  <td class="align-middle p-0 compliance-td">
                     <a class="d-flex align-items-center justify-content-end gap-2 text-decoration-none stock-price"
                        [href]="'/stock/' + stock.stockName + '/'">
                        <span *ngIf="stock.marketcap; else noPrice">
                           {{ stock.marketcap | currencyMilion: stock.currency : true }}
                        </span>
                        <ng-template #noPrice>-</ng-template>
                     </a>
                  </td>

                  <td class="align-middle p-0 compliance-td">
                     <a class="d-flex align-items-center justify-content-end gap-2 text-decoration-none stock-compliance"
                        href="/stock/{{ stock.stockName }}/">

                        <app-compliance-chip [symbol]="stock.ticker" [preloaded]="true"
                           [complianceStatus]="stock?.shariahCompliantStatus" [complianceRankingV2]="stock?.ranking_v2"
                           [preloaded]="true" [onlyRanking]="true">
                        </app-compliance-chip>
                     </a>
                  </td>
               </tr>
            </ng-container>
            <ng-template #noStocks>
               <tr class="bg-white no-data-tr">
                  <td class="align-middle text-center p-3" colspan="7">
                     0 matching stocks
                  </td>
               </tr>
            </ng-template>
         </tbody>
      </table>
   </div>
</ng-container>
